import { setToken } from '@/local/user'
import { setAppBarMode } from '@/utils/bridge'

(function setupLoginToken() {
    let queryString = window.location.search
    if (queryString.startsWith('?')) {
        queryString = queryString.substring(1)
    }
    if (queryString === '') {
        return
    }
    let kvs = queryString.split('&')
    for (let i in kvs) {
        let kv = kvs[i]
        if (kv.startsWith('mo-token')) {
            let token = kv.substring('mo-token='.length)
            setToken(token)
            console.log('set token from query: ', token)
        }
        if (kv.startsWith('app-bar-mode')) {
            let mode = kv.substring('app-bar-mode='.length)
            setAppBarMode(mode)
            console.log('set app bar mode: ', mode)
        }
    }
})()
